import ApiService from '@/services/api.service'

const StateService = {

    getAll() {
       return ApiService.get('/States');
    },

    get(id) {
      return ApiService.get(`/States/${id}`);
    },
}

export default StateService;
